module.exports = "<div class=\"modal-body\">\n    <share-menu post-id=\"postId\" filters=\"filters\"></share-menu>\n</div>\n";